import React from 'react';
import { Link } from 'react-router-dom';
import './Error404.css';

const Error404 = () => {
  return (
    <div className="error-404">
      <div className="error-404-container">
        <div className="error-404-content">
          <h1 className="error-404-title">404</h1>
          <h2 className="error-404-subtitle">Strona nie została znaleziona</h2>
          <p className="error-404-text">
            Przepraszamy, ale strona której szukasz nie istnieje lub została przeniesiona.
          </p>
          <Link to="/" className="error-404-button">
            Przejdź na stronę główną
          </Link>
        </div>
        <div className="error-404-illustration">
          <div className="error-404-icon">⚡</div>
        </div>
      </div>
    </div>
  );
};

export default Error404;